export const DECLINE_ETAPES_PRACTICE_INVITE_MODAL = 'DeclineEtapesPracticeInviteModal';
export const DECLINE_PRACTICE_INVITE_MODAL = 'DeclinePracticeInviteModal';
export const ERROR_MODAL = 'ErrorModal';
export const GENERAL_MODAL = 'GeneralModal';
export const OK_MODAL = 'OkModal';
export const REMOVE_CONNECTION_MODAL = 'RemoveConnectionModal';
export const REMOVE_CONSENT_MODAL = 'RemoveConsentModal';
export const UNLINK_ETAPES_PRACTICE_MODAL = 'UnlinkEtapesPracticeModal';
export const UNLINK_PRACTICE_MODAL = 'UnlinkPracticeModal';
export const CONSENT_INFO_MODAL = 'ConsentInfoModal';
export const STOP_QUICK_SHARE_MODAL = 'StopQuickShareModal';
export const ERROR_LOADING_MODAL = 'ErrorLoadingModal';
export type ModalTypes =
  | typeof DECLINE_ETAPES_PRACTICE_INVITE_MODAL
  | typeof DECLINE_PRACTICE_INVITE_MODAL
  | typeof ERROR_MODAL
  | typeof GENERAL_MODAL
  | typeof OK_MODAL
  | typeof REMOVE_CONNECTION_MODAL
  | typeof REMOVE_CONSENT_MODAL
  | typeof UNLINK_ETAPES_PRACTICE_MODAL
  | typeof UNLINK_PRACTICE_MODAL
  | typeof CONSENT_INFO_MODAL
  | typeof STOP_QUICK_SHARE_MODAL
  | typeof ERROR_LOADING_MODAL;
